var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChackedIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    stroke: "#1F2226"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 14.0573L12.1094 18.75L20.875 8.47919",
    stroke: "#1F2226"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChackedIc);
export default __webpack_public_path__ + "static/media/chacked_ic.17db5d6c5fbd031c26b34d66dd63ed4c.svg";
export { ForwardRef as ReactComponent };